import { SegmentTargetingConfigTypename } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc';
import { isInProgress } from 'personalization-lib/utils/aiStatus';
import { getSegmentId, getSegmentType } from 'personalization-lib/utils/executionInputs';

// Prep for BE updates: some endpoints already return targetingConfig,
// others don't so we treat segmentIdentifier as a fallback
export const getSegment = ({
  segmentIdentifier,
  targetingConfig
}) => {
  const segmentFromTargetingConfig = targetingConfig &&
  // targetingConfig may have other types in the future
  'segmentIdentifier' in targetingConfig && targetingConfig.segmentIdentifier;
  return segmentFromTargetingConfig || segmentIdentifier;
};
export const buildTargetingConfig = segmentIdentifier => ({
  segmentIdentifier,
  __typename: SegmentTargetingConfigTypename
});
export const getStrategySegmentIds = (segmentType, strategy) => {
  if (!strategy) {
    return [];
  }
  const inUseSegments = strategy.personalizations.flatMap(variant => {
    const segment = getSegment(variant);
    return (segment === null || segment === void 0 ? void 0 : segment.segmentType) === segmentType ? [segment.implementationObjectId] : [];
  });
  const aiRequestSegments = strategy.aiExecutionRequests.filter(({
    typedInputs,
    status
  }) => isInProgress(status) && getSegmentType(typedInputs) === segmentType).map(({
    typedInputs
  }) => getSegmentId(typedInputs));
  return [...inUseSegments, ...aiRequestSegments];
};